<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      :preloader="preloader"
      @close-modal="closeModal"
    >
      <template slot="header"> 
        <h5>{{modalTitle}}</h5>
      </template>
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="addUrl">
            <div class="form-group row align-items-center">
              <div class="col-12 mb-2">
                <h5>Default Theme</h5>
              </div>

               <div class="col-6 p-2">
                <label for="inputs_form_header_color" class="mb-0">{{ $t("Header background color") }}</label>
                <input id="inputs_form_header_color" class="form-control color-style" type="color" v-model="form_header_color"/>
              </div>

              <div class="col-6 p-2">
                <label for="form_header_text_color" class="mb-0">{{ $t("Header text color") }}</label>
                <input id="form_header_text_color" class="form-control color-style" type="color" v-model="form_header_text_color"/>
              </div>

              <div class="col-6">
                <label for="inputs_form_color" class="mb-0">{{ $t("form_color") }}</label>
                <input id="inputs_form_color" class="form-control color-style" type="color" v-model="form_color"/>
              </div>  
              <div class="col-6">
                <label for="inputs_font_color" class="mb-0">{{ $t("font_color") }}</label>
                <input id="inputs_font_color" class="form-control color-style" type="color" v-model="font_color"/>
              </div>
              <div class="col-12">
              <label for="inputs_font_color" class="mb-0">{{ $t("form_view") }}</label>
                <div class="box-02 text-center">
                  <h4 class="box-header-text-color">Form Header</h4>
                </div>
                <div class="box-01">
                  <h4 class="box-text-color">Form Body</h4>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 mb-2">
                <h5>Select header content</h5>
              </div>
              <div class="col-6 mb-2">
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('logo')"
                      v-model="companyInfoCheck.checked_logo"
                  />
                </div>
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('company_name')"
                      v-model="companyInfoCheck.checked_company_name"
                  />
                </div>
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('company_number')"
                      v-model="companyInfoCheck.checked_company_number"
                  />
                </div>
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('category_name')"
                      v-model="companyInfoCheck.checked_category_name"
                  />
                </div>
              </div>
              <div class="col-6 mb-2">
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('company_email')"
                      v-model="companyInfoCheck.checked_company_email"
                  />
                </div>
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('company_phone')"
                      v-model="companyInfoCheck.checked_company_phone"
                  />
                </div>
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('address')"
                      v-model="companyInfoCheck.checked_address"
                  />
                </div>
                <div class="form-group mb-0">
                  <app-input
                      type="single-checkbox"
                      :list-value-field="$t('description')"
                      v-model="companyInfoCheck.checked_description"
                  />
                </div>
              </div>
            </div>
          </form>
      </template>
      <template slot="footer">
        <div class="row mt-2 text-right" >
          <div class="col-md-12">
              <button class="btn btn-secondary" @click="closeModal()">{{$t('cancel')}}</button>
              <button class="btn btn-primary" @click.prevent="submit()">{{$t('save')}}</button>
          </div>
        </div>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import * as actions from "../../../../Config/ApiUrl";
// import {  } from "../../../../Helpers/AxiosHelper";
// import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  data() {
    return {
      addUrl: actions.FORM_THEME_STORE,
      preloader: false,
      inputs: {},
      modalId: "demo-form-theme-Modal",
      modalTitle: this.$t("form_theme"),
      companyInfoCheck: {
        checked_company_name: false,
        checked_logo: false,
        checked_company_number: false,
        checked_company_email: false,
        checked_company_phone: false,
        checked_address: false,
        checked_description: false,
        checked_category_name: false,
      },
      formTheme: {},
      form_color: "",
      form_header_color: "",
      form_header_text_color: "",
      font_color: "",
      root: null,
    };
  },
  created() {
    this.getFormTheme();
  },
  methods: {
    getFormTheme() {
      this.preloader = true,
      axiosGet(actions.FORM_THEME_GET)
        .then((res) => {
          if (res.data.status == 'success') {
            this.companyInfoCheck = JSON.parse(res.data.result.header_content);
            var theme_style = JSON.parse(res.data.result.body_style);
            this.form_color = theme_style[0].form_color;
            this.font_color = theme_style[0].font_color;
            this.form_header_color = theme_style[0].form_header_color;
            this.form_header_text_color = theme_style[0].form_header_text_color;

            this.root.style.setProperty("--form-color", this.form_color);
            this.root.style.setProperty("--form-header-color", this.form_header_color);
            this.root.style.setProperty("--form-header-text-color", this.form_header_text_color);

            this.root.style.setProperty("--font-color", this.font_color); 
          }
          this.preloader = false;
        })
        .catch((error) => {
          
        });
    },
    submit() {
      if(this.form_color == '' && this.font_color == '') {
          this.$toastr.w('Please choose form theme color');
      }
      else if(this.form_color == '') {
          this.$toastr.w('Please choose form background color');
      }
      else if(this.font_color == '') {
          this.$toastr.w('Please choose form text color');
      }
      else {
        this.formTheme.theme_no = 0;
        this.formTheme.form_header_color = this.form_header_color;
        this.formTheme.form_header_text_color = this.form_header_text_color;
        this.formTheme.form_color = this.form_color;
        this.formTheme.font_color = this.font_color;
        let theme = [this.formTheme];
        
        this.inputs.body_style = JSON.stringify(theme);
        this.inputs.header_content = JSON.stringify(this.companyInfoCheck);

        this.save(this.inputs);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      $("#"+this.modalId).modal("hide");
    },
  },
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    this.root = document.documentElement;
  },
  watch:{
    form_color() {
      this.root.style.setProperty("--form-color", this.form_color);
    },
    font_color() {
      this.root.style.setProperty("--font-color", this.font_color);
    },
    form_header_color() {
      this.root.style.setProperty("--form-header-color", this.form_header_color);
    },
    form_header_text_color() {
      this.root.style.setProperty("--form-header-text-color", this.form_header_text_color);
    },
  },
};
</script>
<style>
:root {
  --form-color: #ffffff;
  --font-color: #000;
}
.color-style {
  height: 50px !important;
}
.box-text-color {
  margin: auto;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
}
.box-01 {
  color: var(--font-color);
  padding: 6px;
  border: 2px solid #000;
  background-color: var(--form-color);
}
.box-02 {
  color: var(--form-header-text-color);
  padding: 6px;
  border: 2px solid #000;
  background-color: var(--form-header-color);
}
</style>
